import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "responded",
  "use": "responded-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"responded\"><defs><style>#responded .cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px}</style></defs><path class=\"cls-1\" d=\"M144.93 299.31c-14.47 8.94-33.82 14.23-58.47 14.23 14.77-10.21 23.23-22.07 26.66-40.45a113.34 113.34 0 1 1 31.81 26.22z\" /><path class=\"cls-1\" d=\"M166.5 205.71l21.13 21.22 49.87-49.86\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol